var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{directives:[{name:"masonry",rawName:"v-masonry"}],attrs:{"align":"start","no-gutters":""}},[(
                _vm.accessCrud.some((x) => x.e && x.e == 'Customer') &&
                _vm.accessCrud.find((x) => x.e == 'Customer').r
            )?_c('v-col',{attrs:{"cols":"12","justify":"center","lg":"6","md":"12","xl":"4"}},[_c('Accisure',{on:{"hook:mounted":_vm.redrawMasonry}})],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }